import { render, staticRenderFns } from "./jaundiceInfo.vue?vue&type=template&id=56b95261&scoped=true"
import script from "./jaundiceInfo.vue?vue&type=script&lang=js"
export * from "./jaundiceInfo.vue?vue&type=script&lang=js"
import style0 from "./jaundiceInfo.vue?vue&type=style&index=0&id=56b95261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b95261",
  null
  
)

export default component.exports